import { DataRequest } from 'shared/data/datarequest';

import { WorkItem } from 'runtime/data/workitem';

export class WorkItemViewInfo {
    cacheToken: string;
    workItem: WorkItem;
    viewName: string;
    lastPublishTime: string;
    currentUserId: string;
    currentUsername: string;
    currentUserDisplayName: string;
    initialDataChanges: DataRequest[];
    offerClaim: boolean;
}